import IterableDataProcessor from "../../entities/IterableDataProcessor.js";
import ResultData from "../../enums/ResultData.js";
import ResultFormatterBase from "../ResultFormatterBase.js";

class InvertingValueFormatter extends ResultFormatterBase
{
    constructor(sourceDataParameter, destinationDataParameter, fallback, path)
    {
        if (!(sourceDataParameter instanceof Object)) {
            throw new TypeError('sourceDataParameter must be an object');
        }

        if (!sourceDataParameter.hasOwnProperty('key')) {
            throw new TypeError('sourceDataParameter must have an "key" property');
        }

        if (!(destinationDataParameter instanceof Object)) {
            throw new TypeError('destinationDataParameter must be an object');
        }

        if (!destinationDataParameter.hasOwnProperty('key')) {
            throw new TypeError('destinationDataParameter must have an "key" property');
        }

        super();

        this.sourceDataParameter = sourceDataParameter;
        this.destinationDataParameter = destinationDataParameter;
        this.sourcePath = (path || [ResultData.Data.key]).concat([this.sourceDataParameter.key]);
        this.destinationPath = (path || [ResultData.Data.key]).concat([this.destinationDataParameter.key]);
        this.fallback = fallback;
    }

    format(result) {
        if (!result) {
            return result;
        }

        const sourceValue = IterableDataProcessor.getObjectContent(result, this.sourcePath);
        if (!isNaN(sourceValue)) {
            const inverted = -1 * sourceValue;
            IterableDataProcessor.setObjectContent(result, this.destinationPath, inverted);
        }
        else {
            IterableDataProcessor.setObjectContent(result, this.destinationPath, this.fallback);
        }

        return result;
    }
};

export default InvertingValueFormatter;